import React from 'react';
export function Diferenciacion() {
  return <section className="bg-white py-12 md:py-20 px-4" data-id="element-27">
      <div className="max-w-6xl mx-auto" data-id="element-28">
        <img src="https://cdn.magicpatterns.com/uploads/b9hFXUkkaJopdkec9RS6oQ/4d8ac763-2016-4951-a810-eef3081718be.png" alt="Los 10 activos naturales de ESBELTA® y sus beneficios" className="w-full h-auto rounded-2xl" data-id="element-29" />
      </div>
    </section>;
}